var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ReportBuilder", {
        attrs: { viewModel: _vm.reportBuilder },
        on: { "create-report": _vm.handleCreateReportCommand },
      }),
      _vm._v(" "),
      _c("ReportEditor", {
        attrs: { viewModel: _vm.reportEditor },
        on: { "update-report": _vm.handleUpdateReportCommand },
      }),
      _vm._v(" "),
      _c("PortfolioOrDecisionNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.projectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: { role: "button" },
                  on: { click: _vm.showReportCreator },
                },
                [_vm._v("Create report")]
              ),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", {
        staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        !_vm.rm
          ? _c("h3", [
              _c("i", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" Loading... "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.rm
          ? _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-4 offset-lg-8" }, [
                  _c("div", { staticClass: "input-group input-group-lg" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.SearchPhrase,
                          expression: "SearchPhrase",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "search",
                        placeholder: "Search for a report...",
                      },
                      domProps: { value: _vm.SearchPhrase },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.SearchPhrase = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(2),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "table",
                {
                  staticClass:
                    "table table-bordered table-hover table-browser mt-3",
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "sortable",
                          class: { selected: _vm.OrderBy === "name" },
                          on: { click: _vm.OrderByNameCommand },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-uppercase font-weight-normal",
                            },
                            [_vm._v("Name")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fa-stack" }, [
                            _c("i", {
                              staticClass: "fa fa-sort-asc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "name" &&
                                  _vm.OrderByDescending === false,
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-sort-desc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "name" &&
                                  _vm.OrderByDescending === true,
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "sortable text-center",
                          class: { selected: _vm.OrderBy === "modified" },
                          staticStyle: { width: "180px" },
                          on: { click: _vm.OrderByModifiedCommand },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-uppercase font-weight-normal",
                            },
                            [_vm._v("Updated on")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fa-stack" }, [
                            _c("i", {
                              staticClass: "fa fa-sort-asc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "modified" &&
                                  _vm.OrderByDescending === false,
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-sort-desc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "modified" &&
                                  _vm.OrderByDescending === true,
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "sortable text-center",
                          class: { selected: _vm.OrderBy === "created" },
                          staticStyle: { width: "180px" },
                          on: { click: _vm.OrderByCreatedCommand },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "text-uppercase font-weight-normal",
                            },
                            [_vm._v("Created on")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fa-stack" }, [
                            _c("i", {
                              staticClass: "fa fa-sort-asc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "created" &&
                                  _vm.OrderByDescending === false,
                              },
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-sort-desc fa-stack-1x",
                              class: {
                                selected:
                                  _vm.OrderBy === "created" &&
                                  _vm.OrderByDescending === true,
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("th", { staticStyle: { width: "90px" } }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.ReportsView, function (r) {
                      return _c("tr", { key: r.ReportId }, [
                        _c("td", [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: _vm.url_ReportViewPage(r.ReportId),
                                  expression: "url_ReportViewPage(r.ReportId)",
                                },
                              ],
                              staticClass: "text-dark",
                            },
                            [_c("span", [_vm._v(_vm._s(r.Name))])]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getFormattedDateStr(r.Modified))),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(_vm._s(_vm.getFormattedTimeStr(r.Modified))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-center" }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getFormattedDateStr(r.Created))),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(_vm._s(_vm.getFormattedTimeStr(r.Created))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "dropdown" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-outline-secondary dropdown-toggle",
                                attrs: {
                                  type: "button",
                                  "data-toggle": "dropdown",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                    Actions\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: {
                                      href: `/#/sharing/resource/ReportsDataShareResourceProvider/${r.ReportId}`,
                                    },
                                  },
                                  [_vm._v("Share")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-divider" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showReportEditor(r)
                                      },
                                    },
                                  },
                                  [_vm._v("Edit")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCloneReportCommand(r)
                                      },
                                    },
                                  },
                                  [_vm._v("Clone")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-divider" }),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteReportCommand(r)
                                      },
                                    },
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Reports")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "a",
      {
        staticClass: "btn btn-outline-secondary btn-lg",
        attrs: {
          href: "https://www.transparentchoice.com/user-guide/reports",
          title: "User guide: Report results",
          target: "_blank",
        },
      },
      [_c("i", { staticClass: "fa fa-info", attrs: { "aria-hidden": "true" } })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", {
          staticClass: "fa-solid fa-magnifying-glass",
          attrs: { "aria-hidden": "true" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }